import * as React from "react";
import { SVGProps } from "react";
function SvgMeetingPauseRecIconModal(
  props: SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 25.334h5.333V6.667H8v18.667ZM18.667 6.667v18.667H24V6.667h-5.333Z"
        fill="#000"
      />
    </svg>
  );
}
export default SvgMeetingPauseRecIconModal;
